import { useQuery } from 'react-query';

import { RefundJournalApi } from '../api';
import { RefundJournal } from '../mappers';
import { IEntity } from '../types';

const useRefundJournal = ({ id }: { id: number }) => {
  const initialData = { items: [] };

  const { data = initialData, ...args } = useQuery<{ items: IEntity.RefundJournal[] }, string, any>({
    queryKey: ['refund-journal', id],
    queryFn: async () => {
      const { data } = await RefundJournalApi({ id });

      const items = (data || []).map(item => RefundJournal(item));
      return { items };
    },
    enabled: !!id,
    retry: false,
    initialData
  });

  return { data, ...args };
};

export default useRefundJournal;
